import { Add, ChevronLeft, ChevronRight, ExitToApp, ImageRounded, Public } from '@mui/icons-material';
import { Divider, List, ListItemButton, ListItemIcon, ListItemText, Toolbar, IconButton } from '@mui/material';
import React, { useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import logo from 'url:../../../assets/docsi_logo.svg';
import { useGetOrganizationsQuery } from '../../api/apiSlice';
import OrganizationEntry from './SuperSettingsSidebar/OrganizationEntry';

function SuperSettingsSidebarContents({ collapsed = false, onToggleCollapse }) {
    const params = useParams();
    const pathnames = useLocation().pathname.split('/');
    const navigate = useNavigate();
    const { data: organizations = [], isLoading } = useGetOrganizationsQuery();

    const selectedIndex = useMemo(() => {
        if (params.organizationId) {
            return 'org' + params.organizationId;
        } else if (params.hospitalId) {
            return 'hos' + params.hospitalId;
        } else if (pathnames.includes('create') && pathnames.includes('organizations')) {
            return 'createOrg';
        } else if (pathnames.includes('organizations')) {
            return 'organizations';
        } else if (pathnames.includes('itemImageReview')) {
            return 'imageReview';
        } else {
            return '';
        }
    }, [params]);

    return (
        !isLoading &&
        <>
            <Toolbar sx={{ padding: '16px', display: 'flex', justifyContent: collapsed ? 'center' : 'space-between', alignItems: 'center' }}>
                {!collapsed && <img src={logo} alt='Site Logo' style={{ objectFit: 'contain' }} width={150} />}
                <IconButton onClick={onToggleCollapse} size="small" aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}>
                    {collapsed ? <ChevronRight /> : <ChevronLeft />}
                </IconButton>
            </Toolbar>
            <Divider />
            <List>
                <ListItemButton key={0} onClick={() => navigate('/cards')} aria-label="Exit to Admin Portal">
                    <ListItemIcon><ExitToApp /></ListItemIcon>
                    {!collapsed && <ListItemText primary='Exit to Admin Portal' />}
                </ListItemButton>
                <ListItemButton key={1} selected={selectedIndex === 'organizations'} onClick={() => navigate('/superSettings/organizations')} aria-label="All Organizations">
                    <ListItemIcon><Public /></ListItemIcon>
                    {!collapsed && <ListItemText primary='Organizations' />}
                </ListItemButton>
                <ListItemButton key={2} selected={selectedIndex === 'createOrg'} onClick={() => navigate('/superSettings/organizations/create')} aria-label="Create New Organization">
                    <ListItemIcon><Add /></ListItemIcon>
                    {!collapsed && <ListItemText primary='Create New Organization' />}
                </ListItemButton>
                <ListItemButton key={3} selected={selectedIndex === 'imageReview'} onClick={() => navigate('/superSettings/itemImageReview')} aria-label="Item Image Review">
                    <ListItemIcon><ImageRounded /></ListItemIcon>
                    {!collapsed && <ListItemText primary='Item Image Review' />}
                </ListItemButton>
            </List>
            <Divider />
            {!collapsed && (
                <List style={{ overflowY: 'scroll' }}>
                    {organizations.map((organization) => (
                        <OrganizationEntry 
                            key={organization.id}
                            organization={organization} 
                            selectedIndex={selectedIndex}
                        />
                    ))}
                </List>
            )}
        </>
    );
}

export default SuperSettingsSidebarContents;